module.exports = __webpack_public_path__ + "img/Icon_Document-Check.80c253df.svg";